export const NORTH_AMERICAN_PHONE_REGEX = /^\+1[2-9]\d{2}[2-9]\d{6}$/;
export const NORTH_AMERICAN_PHONE_ERROR = 'Please enter a valid US or Canada phone number';
export const NORTH_AMERICAN_PHONE_PLACEHOLDER = 'Enter phone in format: +1 (555) 555-1234';
